// eslint-disable-next-line eag/no-external-date-time-format-functions -- It is intended to use it here
import {format} from 'date-fns';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

const testDate = new Date();

export function validateDateTimeFormat(value: string | Nullish) {
  if (isNil(value)) {
    return false;
  }
  try {
    format(testDate, value);
    return true;
  } catch {
    return false;
  }
}
